import Typography from '@liquidweb-dev/undercurrent/Typography';
import ChartColumnIcon from '@liquidweb-dev/undercurrent/icons/lucide/ChartColumn';
import { DialogProps } from '@liquidweb-dev/undercurrent/Dialog';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Box from '@liquidweb-dev/undercurrent/Box';
import DDOSProtection from 'images/advanced-ddos-protection.png';
import DialogUTM from '../DialogUTM';

interface AdvancedDDosProtectionProps extends Omit<DialogProps, 'onClose'> {
	onClose: () => void;
}
const AdvancedDDosProtection = ({
	onClose,
	...props
}: AdvancedDDosProtectionProps) => {
	return (
		<DialogUTM
			onClose={onClose}
			title="Manage and protect your server"
			image={DDOSProtection}
			badge={{
				icon: ChartColumnIcon,
				label: 'Advanced Tools & Uptime',
			}}
			dialogContent={{
				title: 'Manage and protect your server',
				description: (
					<Typography variant="body-md">
						<Stack gap={300}>
							<Box>
								Reboot your server anytime from the{' '}
								<Typography fontWeight={700}>three-dot menu</Typography>, and
								review logs in the Activity Log tab to monitor changes or
								troubleshoot issues.
							</Box>
							<Box>
								For added security, go to the{' '}
								<Typography fontWeight={700}>Settings tab</Typography> to add-on
								Advanced DDoS Protection and safeguard against spikes and
								attacks.
							</Box>
						</Stack>
					</Typography>
				),
			}}
			{...props}
		/>
	);
};

export default AdvancedDDosProtection;
